export enum FeatureFlagId {
  // Patient Medication History
  PatientMedicationHistory = 'patient_medication_history',

  // Program Facilitation
  AddProgramToIntake = 'add_program_interaction_to_intake',
  ProgramConfiguration = 'program_configuration',
  InitialAndFollowUpInteraction = 'initial_followup_interaction',
  AdHocInteraction = 'adhoc_interaction',
  RemoteInteraction = 'remote_interaction',

  // Site Administration
  DataIntegrations = 'data_integrations',

  // Test Features
  FeatureFlagTest = 'feature_flag_test',

  // Workflow
  BypassPatientSignature = 'bypass_patient_signature',

  RestoreCancelledVisit = 'restore_cancelled_visit',
}
